import { z } from "zod";

const WORK_FORMAT_VALUES = ["onsite", "remote", "hybrid"];

export const experienceSchema = z
  .object({
    organization_name: z.string().min(1, { message: "validation.experience.organization_required" }),
    speciality: z.string().min(1, { message: "validation.experience.speciality_required" }),
    work_position: z.string().min(1, { message: "validation.experience.position_required" }),
    work_format: z.string().refine((value) => WORK_FORMAT_VALUES.includes(value), {
      message: "validation.experience.work_format_required",
    }),
    work_address: z.string().min(1, { message: "validation.experience.address_required" }),
    begin_month: z.number().nullable(),
    begin_year: z.number().nullable(),
    end_month: z.number().nullable(),
    end_year: z.number().nullable(),
    is_current: z.boolean(),
  })
  .superRefine(function refineExperience(data, ctx) {
    if (data.begin_month == null || data.begin_year == null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "validation.experience.begin_required",
        path: ["begin_month"],
      });
    }
    if (data.is_current) return;
    if (data.end_month == null || data.end_year == null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "validation.experience.end_required",
        path: ["end_month"],
      });
      return;
    }
    if (data.begin_month != null && data.begin_year != null) {
      const begin = data.begin_year * 100 + data.begin_month;
      const end = data.end_year * 100 + data.end_month;
      if (end < begin) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "validation.experience.end_before_begin",
          path: ["end_month"],
        });
      }
    }
  });

export type ExperienceFormValues = z.infer<typeof experienceSchema>;
